// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.idm {
  --panel-bg: #fbf5fb;
  --num-bg: #e6e0ea;
  --text: #1f1f1f;
  --muted: #6b6b6b;

  display: grid;
  gap: 10px;

  overflow-x: auto;
  padding-bottom: 15px;
}

.idm__header {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  margin-bottom: 10px;
  box-sizing: border-box;
  max-width: 100%;
}

.idm__hcell {
  font-size: 14px;
  font-weight: 600;
  color: #013868;
  line-height: 1.15;
}

.idm__hcell--left {
  font-size: 17px;
  width: 537px;
}

.idm__hcell--col {
  width: 130px;
  text-align: center;
}

.idm__hcell--colmore {
  width: 130px;
  text-align: center;
}

.idm__body {
  display: grid;
  gap: 10px;
}

.idm__row {
  display: flex;
  align-items: center;
  /* gap:  40px; */
  box-sizing: border-box;
  max-width: 100%;
}

.idm__left {
  width: 520px;
  background: #eef3f7;
  border-radius: 4px;
  padding: 14px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-right: 50px;
}

.idm__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text);
  font-size: 17px;
}

.idm__qty {
  color: var(--text);
  white-space: nowrap;
}

.idm__cell {
  display: flex;
  align-items: center;
  min-width: 0;
  width: 150px;
}

.col-amount1 {
  /* flex: 2 1 0; */
}

.idm__num {
  width: 50px;
  height: 50px;
  text-align: center;

  border: 0;
  border-radius: 3px;
  background: #eef3f7;
  color: var(--text);

  outline: none;
  font: inherit;
}

.idm__num::-webkit-inner-spin-button,
.idm__num::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.idm__num {
  -moz-appearance: textfield;
}

.idm__num:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.35);
  outline-offset: 2px;
}

.idm__sum {
  /* margin-left: 10px; */
  font-size: 16px;
  color: var(--muted);
  /* min-width: 56px; */
  text-align: left;
}

.idm__sum.is-over {
  color: #b81a1a;
  font-weight: 600;
}

.controls {
  display: flex;
  flex-direction: column;
}

.controls button {
  flex: 1;
  width: 40px;
  font-size: 14px;
  padding: 4px;
  border: 0px solid #ccc;
  background: #f5f5f5;
  cursor: pointer;
  color: #6b6b6b;
  outline: none;
}

.controls button:focus {
  outline: none;
}

.controls button:focus-visible {
  outline: none;
}

.controls button:not(:disabled):hover {
  background: #e0e0e0;
}

.controls button:not(:disabled):active {
  background: #d0d0d0;
}

.controls button:disabled {
  background: #f0f0f0;
  color: #b5b5b5;
  border-color: #e0e0e0;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/web/component/ItemDispositionMatrix/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,SAAS;;EAET,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;EACb,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".idm {\r\n  --panel-bg: #fbf5fb;\r\n  --num-bg: #e6e0ea;\r\n  --text: #1f1f1f;\r\n  --muted: #6b6b6b;\r\n\r\n  display: grid;\r\n  gap: 10px;\r\n\r\n  overflow-x: auto;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.idm__header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 17px;\r\n  margin-bottom: 10px;\r\n  box-sizing: border-box;\r\n  max-width: 100%;\r\n}\r\n\r\n.idm__hcell {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #013868;\r\n  line-height: 1.15;\r\n}\r\n\r\n.idm__hcell--left {\r\n  font-size: 17px;\r\n  width: 537px;\r\n}\r\n\r\n.idm__hcell--col {\r\n  width: 130px;\r\n  text-align: center;\r\n}\r\n\r\n.idm__hcell--colmore {\r\n  width: 130px;\r\n  text-align: center;\r\n}\r\n\r\n.idm__body {\r\n  display: grid;\r\n  gap: 10px;\r\n}\r\n\r\n.idm__row {\r\n  display: flex;\r\n  align-items: center;\r\n  /* gap:  40px; */\r\n  box-sizing: border-box;\r\n  max-width: 100%;\r\n}\r\n\r\n.idm__left {\r\n  width: 520px;\r\n  background: #eef3f7;\r\n  border-radius: 4px;\r\n  padding: 14px 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-right: 50px;\r\n}\r\n\r\n.idm__label {\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  color: var(--text);\r\n  font-size: 17px;\r\n}\r\n\r\n.idm__qty {\r\n  color: var(--text);\r\n  white-space: nowrap;\r\n}\r\n\r\n.idm__cell {\r\n  display: flex;\r\n  align-items: center;\r\n  min-width: 0;\r\n  width: 150px;\r\n}\r\n\r\n.col-amount1 {\r\n  /* flex: 2 1 0; */\r\n}\r\n\r\n.idm__num {\r\n  width: 50px;\r\n  height: 50px;\r\n  text-align: center;\r\n\r\n  border: 0;\r\n  border-radius: 3px;\r\n  background: #eef3f7;\r\n  color: var(--text);\r\n\r\n  outline: none;\r\n  font: inherit;\r\n}\r\n\r\n.idm__num::-webkit-inner-spin-button,\r\n.idm__num::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.idm__num {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n.idm__num:focus-visible {\r\n  outline: 2px solid rgba(0, 0, 0, 0.35);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.idm__sum {\r\n  /* margin-left: 10px; */\r\n  font-size: 16px;\r\n  color: var(--muted);\r\n  /* min-width: 56px; */\r\n  text-align: left;\r\n}\r\n\r\n.idm__sum.is-over {\r\n  color: #b81a1a;\r\n  font-weight: 600;\r\n}\r\n\r\n.controls {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.controls button {\r\n  flex: 1;\r\n  width: 40px;\r\n  font-size: 14px;\r\n  padding: 4px;\r\n  border: 0px solid #ccc;\r\n  background: #f5f5f5;\r\n  cursor: pointer;\r\n  color: #6b6b6b;\r\n  outline: none;\r\n}\r\n\r\n.controls button:focus {\r\n  outline: none;\r\n}\r\n\r\n.controls button:focus-visible {\r\n  outline: none;\r\n}\r\n\r\n.controls button:not(:disabled):hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.controls button:not(:disabled):active {\r\n  background: #d0d0d0;\r\n}\r\n\r\n.controls button:disabled {\r\n  background: #f0f0f0;\r\n  color: #b5b5b5;\r\n  border-color: #e0e0e0;\r\n  cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
